import React from "react"

import { connect } from "scrivito"
import { ProductPositionAddon } from "shared/types/__generated__/graphql"
import { RowRendererProps } from "shared/ui/table/types"

import { useProductInformation } from "entities/products/model/useProductInformation"

import { ProductPositionTableProductPositionAddonRowView } from "./ProductPositionTableProductPositionAddonRowView"

export function ProductPositionTableProductPositionAddonRowComponent(
  props: RowRendererProps<ProductPositionAddon>
) {
  const { item } = props

  const { title } = useProductInformation({
    variantKey: item.variantKey,
    parentProductType: item.parentProductType
  })

  return (
    <ProductPositionTableProductPositionAddonRowView {...props} title={title} />
  )
}
export const ProductPositionTableProductPositionAddonRow = React.memo(
  connect(ProductPositionTableProductPositionAddonRowComponent)
) as typeof ProductPositionTableProductPositionAddonRowComponent
